import { createSender, r } from '@/plugins/resource'
import { prefixAPI, queryPostfix } from '@/plugins/resource/api'

const MODEL = 'service-moderation'
const ACTION_MODEL = MODEL + '/action'

export const SERVICE_MODERATION_REASONS_LIST_URL = prefixAPI(MODEL + '/reason/list/')

export const serviceModerationApi = {
  action: {
    confirmAndActivate: r('/confirm-and-active/', ACTION_MODEL, createSender),
    confirm: r('/confirm/', ACTION_MODEL, createSender),
    reject: r('/reject/', ACTION_MODEL, createSender),
  },
  // history: r(queryPostfix('/history/list/{id}/', ['filters']), MODEL),
  list: r(queryPostfix('/list/', ['filters']), MODEL),
  filterList: r('/filter-list/', MODEL),
  detail: r('/detail{/id}/', MODEL),
  reasonList: r('/reason/list/', MODEL),
}
